module.exports = __webpack_public_path__ + "img/jnrh-hub.0fb885b3.jpg";